import * as signalR from "@microsoft/signalr";
import { getAccessToken } from '../utils/authStorage';

const URL = process.env.REACT_APP_SIGNALR_HUB_URL || '';

let connection = null;

export const getSignalRConnection = () => {
    const token = getAccessToken();
    if (token != null) {
        if (!connection) {
            connection = new signalR.HubConnectionBuilder()
                .withUrl(`${URL}`, {
                    // Always get the latest token from storage dynamically
                    accessTokenFactory: () => {
                        if (!token) {
                            console.warn('No access token available for SignalR connection');
                        }
                        return token || '';
                    },
                })
                .withAutomaticReconnect()
                .build();
        }
    }
    return connection;
};

// Function to recreate connection with new token (useful after token refresh)
export const recreateSignalRConnection = () => {
    if (connection) {
        connection?.stop().catch(err => console.error('Error stopping SignalR connection:', err));
        connection = null;
    }
    return getSignalRConnection();
};